module.exports = __webpack_public_path__ + "media/images/pokerroom/888/step2-pict02-full-7948643d6c64f180fd7c6488b74718e6.jpg";